import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import uiController from './modules/ui-controller';
import quickSearch from './modules/quick-search';
import quickMovieSearch from './modules/quick-movie-search';
import quickTVSearch from './modules/tvShows/quickTVsearch';
import querySearch from './modules/query-search';
import paramSearch from './modules/param-search';
import favors from './modules/favors';
import people from './modules/people';
import detailsModal from './modules/details-modal';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    uiController,
    quickSearch,
    quickMovieSearch,
    quickTVSearch,
    querySearch,
    paramSearch,
    favors,
    people,
    detailsModal,
  },
});
